export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=40de9deb7b3512d52cdc7a06808a2aa5a2f62348c4&name=addToFolderEventAction!'